function HotSelected() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.25" cy="26" r="26" fill="#0D0F11"/>
            <path
                d="M22.4124 38.925H24.1214H25.8038H27.5128C30.4122 38.925 32.7626 36.5746 32.7626 33.6752V32.3V28.3124C32.7626 27.5876 32.175 27 31.4502 27H22.3626H18.475C17.7502 27 17.1626 27.5876 17.1626 28.3124V32.3V33.6752C17.1626 36.5746 19.513 38.925 22.4124 38.925Z"
                stroke="white" strokeWidth="2"/>
            <path
                d="M26.2626 22.025H19.1501C18.0524 22.025 17.1626 21.1351 17.1626 20.0375C17.1626 18.9398 18.0524 18.05 19.1501 18.05H30.1251C31.2228 18.05 32.1126 17.1601 32.1126 16.0625C32.1126 14.9648 31.2228 14.075 30.1251 14.075H23.0126"
                stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path
                d="M33.5948 28.325H35.8628C37.0225 28.325 37.9627 29.2651 37.9627 30.4249V31.525C37.9627 32.6848 37.0225 33.625 35.8628 33.625H32.7627"
                stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default HotSelected;
